import { create } from "zustand";

interface PinDetailStore {
  pin: IPin;
  setPin: (pin: IPin) => void;
  // 画板相关状态
  relatedBoardsList?: any;
  boardMatchingResult?: any;
  isNewUser?: boolean;
  onUserBoardUpdate?: (board: any) => void;
  // 画板相关方法
  setBoardData: (data: {
    relatedBoardsList?: any;
    boardMatchingResult?: any;
    isNewUser?: boolean;
    onUserBoardUpdate?: (board: any) => void;
  }) => void;
}

export const usePinDetailStore = create<PinDetailStore>((set) => ({
  pin: null,
  setPin: (pin: IPin) => set({ pin }),
  relatedBoardsList: undefined,
  boardMatchingResult: undefined,
  isNewUser: undefined,
  onUserBoardUpdate: undefined,
  setBoardData: (data) => set(data),
}));
